const TOPICS = [
  { id: 't1', label: '明星塌房', heat: '9.8万', trend: 'up' },
  { id: 't2', label: '网红翻车', heat: '8.2万', trend: 'up' },
  { id: 't3', label: '热搜事件', heat: '7.6万', trend: 'hot' },
  { id: 't4', label: '社会热点', heat: '6.9万', trend: 'up' },
  { id: 't5', label: '娱乐圈大瓜', heat: '6.3万', trend: 'new' },
  { id: 't6', label: '网络争议', heat: '5.7万', trend: 'up' },
  { id: 't7', label: '直播翻车', heat: '5.1万', trend: 'hot' },
  { id: 't8', label: '情感爆料', heat: '4.8万', trend: 'up' },
  { id: 't9', label: '职场热闻', heat: '4.2万', trend: 'new' },
  { id: 't10', label: '科技圈大事件', heat: '3.9万', trend: 'up' },
];

const TREND_ICONS: Record<string, string> = {
  up: 'ri-arrow-up-line',
  hot: 'ri-fire-line',
  new: 'ri-sparkling-line',
};

const TREND_COLORS: Record<string, string> = {
  up: 'text-primary-500',
  hot: 'text-accent-500',
  new: 'text-secondary-600',
};

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门话题标签
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          全网热议的话题都在这里
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((t) => (
            <a
              key={t.id}
              href="#cards"
              className="inline-flex items-center gap-2 bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 rounded-full px-5 py-3 transition-all cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 whitespace-nowrap">
                #{t.label}
              </span>
              <span className="text-xs text-foreground-500 bg-background-200/70 rounded-full px-2 py-0.5 whitespace-nowrap">
                {t.heat}
              </span>
              <span className={`${TREND_COLORS[t.trend]} text-xs`}>
                <i className={TREND_ICONS[t.trend]}></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}